export default function Spinner({ class: clazz, ...props }: IntrinsicElement<"span">) {
  return <span {...props} class={` ${clazz ?? ""} animate animate-spin icon-ri:loader-3-fill`}></span>;
}
